import _ from 'lodash'

export const cookRequestParams = (params) => {
  let newParams = _.cloneDeep(params)

  _.each(newParams, (value, key) => {
    if (key === 'time' && !_.isEmpty(value)) {
      newParams = _.omit(newParams, ['time'])
      newParams.start_date = value[0]
      newParams.end_date = value[1]
      return
    }

    if (_.isArray(value)) {
      newParams[key] = value.filter((item) => item !== '').join()
    }
  })

  return newParams
}
